import { useFormik } from "formik";
import { option_tipo_isapre, option_tipo_paquete } from "../select_data";

type ISearchBills = {
    _handleSearch: any,
    _handleError: any,
    loading: boolean
}

const Search = (props: ISearchBills) => {
    const { _handleSearch, _handleError, loading } = props;

    const initialValues = {
        tipopaquete: '',
        tipoisapre: '',
        codigo_prestacion: '',
        nombre_prestacion: '',
    }

    const formik = useFormik({
        initialValues,
        onSubmit: async (values) => {
            try {
                await _handleSearch(values);
            } catch (e: any) {
                _handleError(e)
            }
        }
    })
    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="card p-10">
                <div className="row fs-4 fw-bold">

                    <div className="col-12 col-md-3 mb-5">
                        <span>Seleccione Tipo Arancel *</span>
                        <select className="form-select" {...formik.getFieldProps("tipopaquete")} >
                            <option value="" disabled>Seleccione...</option>
                            {option_tipo_paquete.map((item: any, index: number) => (
                                <option key={index} value={item.id}>{item.name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-12 col-md-3 mb-10">
                        <span>Seleccione Isapre *</span>
                        <select className="form-select" {...formik.getFieldProps("tipoisapre")} >
                            <option value="" disabled>Seleccione...</option>
                            {option_tipo_isapre.map((item: any, index: number) => (
                                <option key={index} value={item.id}>{item.name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-12 col-md-3 mb-5">
                        <span>Código Prestación (Solo números)</span>
                        <input type="text" className="form-control" {...formik.getFieldProps("codigo_prestacion")} />
                    </div>

                    <div className="col-12 col-md-3 mb-10">
                        <span>Nombre Prestación</span>
                        <input type="text" className="form-control" {...formik.getFieldProps("nombre_prestacion")} />
                    </div>

                    <div className="col-12 text-end">
                        <button type="submit" className="btn btn-sm fw-bold btn-primaryamsm" disabled={loading}>Buscar</button>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default Search;